import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

/**
 * @param {import('./typedefs').AccountType} accountType
 * @param {string} date
 */
function useDaily(accountType, date) {
  const { cb, key } = fetch(accountType, date);

  const { refetch, data, isSuccess } = useQuery(key, cb, {
    select: (_data) => _data.results,
    enabled: false,
  });

  return { refetch, data, isSuccess };
}

export default { useDaily };
